import { render, staticRenderFns } from "./MobChartTable.vue?vue&type=template&id=72f5397c"
import script from "./MobChartTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MobChartTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobChartTable.vue?vue&type=style&index=0&id=72f5397c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports